export default {
    head() {
        const isMainShop = this.$store.getters.isMainShop;

        if (isMainShop) {
            return {
                link: [
                    { rel: 'manifest', href: '/site.webmanifest' },
                    { rel: 'icon', type: 'image/png', href: '/favicon-96x96.png', sizes: '96x96', hid: 'icon-png' }  //only main shop has this
                ]
            };
        }
        return {};
    },
    computed: {
        theme() {
            return this.$store.state.theme;
        }
    },
    methods: {
        injectTheme() {
            if (this.theme) {
                //lazy-once webpack mode is important to preserve the production chunks' size
                //import(`@/themes/${this.theme}/styles/theme.scss`);
                import(`@/themes/${this.theme}/styles/theme.scss`).then(
                    module => {
                        if (module.__inject__) {
                            module.__inject__(this.$ssrContext);
                        }
                    },
                    () => {
                        //there is no theme.scss, then main.scss is sufficient
                        this.importDefaultStylesheet();
                    }
                );
            } else {
                this.importDefaultStylesheet();
            }
        },

        importDefaultStylesheet() {
            import(`@/styles/main.scss`).then(module => {
                if (module.__inject__) {
                    module.__inject__(this.$ssrContext);
                }
            });
        }
    },
    created() {
        this.injectTheme();
    }
};
